import { useForm } from "react-hook-form";
import { addPilot } from "../../api/authAPI";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuthStore } from "../../store/authStore";
import TextField from "../../components/UI/TextField";
import { UserFollow } from "@carbon/icons-react";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { validatePassword } from "../../helpers/commonFunction";

const AddPilotTab = () => {
    const { register, getValues, handleSubmit, reset } = useForm();
    const qClient = useQueryClient();
    const { token, setLoaderState } = useAuthStore((state) => state)
    const addPilotQuery = useMutation({
        mutationFn: addPilot,
        onSuccess: () => {
            // refetch on submit
            setLoaderState(false)
            qClient.invalidateQueries({ queryKey: "getAllUser" });
        },
    })
    const submitUser = () => {
        const data = getValues()
        if (!(data.email?.includes("@"))) {
            return toast.error("Please Enter valid email id")
        }
        setLoaderState(true)
        addPilotQuery.mutate({ token, data })

        // if (validatePassword(data.password)) {
        //     // reset form
        //     // reset();
        // } else {
        //     toast.error("Password Guidelines:\n Atleast 8 character \n Special character@#$%^&* \n Atleast one letter a-z", { style: { whiteSpace: "pre-line" } })
        //     // toast.error("Atleast 8 character" + "\n" + "Special character@#$%^&*")
        // }




    }

    useEffect(() => {
        if (addPilotQuery.error) {
            toast.error(addPilotQuery.error.response.data.message)
            setLoaderState(false)
        }
    }, [addPilotQuery.error])

    useEffect(() => {
        if (addPilotQuery?.data?.data?.message) {
            toast.success(addPilotQuery?.data?.data?.message)
        }
    }, [addPilotQuery.data?.data])
    return (
        <>
            <form
                onSubmit={handleSubmit(submitUser)}
            >
                <ToastContainer />
                <div className="space-y-6 mt-10">
                    <div>
                        <TextField
                            label="Name*"
                            type="name"
                            placeholder={"Enter Name"}
                            inputProps={{ ...register("fullName", { required: true }) }}
                        />
                    </div>
                    <div>
                        <TextField
                            label="Pilot License Number*"
                            type="text"
                            placeholder={"Enter Pilot License Number"}
                            inputProps={{ ...register("licenseNumber", { required: true }) }}
                        />
                    </div>
                    <div>

                        <TextField
                            label="email*"
                            type="email"
                            placeholder={"Enter your email"}
                            inputProps={{ ...register("email", { required: true }) }}
                        />
                    </div>

                    {/* <div>

                        <TextField
                            label="password*"
                            type="password"
                            placeholder={"Enter your password"}
                            inputProps={{ ...register("password", { required: true }) }}
                        />
                    </div> */}

                    <div>
                        <button
                            className="text-xl mt-10 bg-tblu text-white flex justify-center items-center w-full p-4 space-x-1 rounded-xl"
                        >
                            <span><UserFollow /></span> <span>Add</span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    )
}

export default AddPilotTab